module.exports = __webpack_public_path__ + "img/HomeEDC5000.7c4a4895.png";